var ce = Object.defineProperty;
var ue = (t, e, o) => e in t ? ce(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var w = (t, e, o) => ue(t, typeof e != "symbol" ? e + "" : e, o);
import { reactive as D, provide as W, onMounted as le, inject as G, getCurrentInstance as H } from "vue";
import { A as g, f as j, R as S, M as J, B as z, L as y, D as B, g as de, p as pe, h as L, C as Q, i as he } from "./maps.DxC18PqJ.js";
var A = /* @__PURE__ */ ((t) => (t.Active = "active", t.Sending = "sending", t.Success = "success", t.Failure = "failure", t))(A || {});
const me = [
  g.SendForm,
  g.SendSaveSearch,
  g.SendSubscribe
], fe = [
  // TODO: add empty click here and update button component
  g.ApplyDiscount,
  g.OpenUri,
  g.OpenBookingEngine,
  g.NoAction,
  g.Dismiss
], ge = [
  g.Hide
];
class be {
  constructor() {
    w(this, "dataValidators", {});
    w(this, "state", D({
      actions: [],
      buttonState: A.Active,
      stepActive: j.Main,
      stepPrevious: null,
      isFirstStep: !0,
      hideFunction: () => {
      }
    }));
  }
  get buttonState() {
    return this.state.buttonState;
  }
  get isFirstStep() {
    return this.state.isFirstStep;
  }
  get stepActive() {
    return this.state.stepActive;
  }
  get stepPrevious() {
    return this.state.stepPrevious;
  }
  initialize(e, o) {
    this.state.hideFunction = e, this.state.actions = o;
  }
  setStepActive(e, o = null) {
    this.state.stepActive = e, this.state.isFirstStep = e === j.Main, this.state.stepPrevious = o;
  }
  setDataValidator(e, o) {
    this.dataValidators[e] = o;
  }
  // accep type as generic for return
  async callHandler(e, o) {
    if (!this.state.actions) return !1;
    let n = {};
    const r = this.dataValidators[e];
    if (r && (n = await r(), !n))
      return !1;
    let s;
    const a = [
      // Some handlers will never come with a moduleId as they do not belong to any content module (dismiss, show..)
      (i) => i.kind === e,
      // Last hope, look for the None action - the default one
      (i) => i.kind === g.Fallback
    ];
    o && a.unshift((i) => i.moduleId === o);
    for (let i = 0; !s && i < a.length; i += 1)
      s = this.state.actions.find(a[i]);
    if (!s) return !1;
    let c = !1;
    return s.handler && (this.state.buttonState = A.Sending, c = await s.handler(n), this.state.buttonState = A.Active), me.includes(e) && (this.state.stepActive = c ? j.Success : j.Failure, this.state.isFirstStep = !1), fe.includes(e) && this.callHandler(g.Hide), ge.includes(e) && this.state.hideFunction(), c;
  }
  goBackToMainStep() {
    this.state.stepPrevious = this.state.stepActive, this.state.stepActive = j.Main, this.state.isFirstStep = !0;
  }
  reset() {
    this.state.buttonState = A.Active, this.state.stepActive = j.Main, this.state.isFirstStep = !0;
  }
}
function we(t, e = 1) {
  let o = t.replace("#", "");
  if (![3, 6].includes(o.length))
    return null;
  o.length === 3 && (o = o.split("").map((r) => r + r).join(""));
  const n = parseInt(o, 16);
  return `rgba(${n >> 16 & 255},${n >> 8 & 255},${n & 255},${e})`;
}
function at(t) {
  const e = t.replace(/[-_\s]+(.)?/g, (o, n) => n ? n.toUpperCase() : "");
  return e.substring(0, 1).toUpperCase() + e.substring(1);
}
function Y(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
const ct = (t) => t.replace(/[A-Z]/g, (e) => `_${e.toLowerCase()}`);
function $e(t) {
  switch ((t == null ? void 0 : t.kind) || S.Rounded) {
    case S.Custom:
      const o = t;
      return `${o.value}${o.format}`;
    case S.Square:
      return "0px";
    case S.Medium:
      return "6px";
    case S.Rounded:
    default:
      return "16px";
  }
}
function ye(t = 0) {
  return `${t}px`;
}
function ut(t = 0) {
  return `${t}%`;
}
function lt(t = 0) {
  return `${t}em`;
}
function O(t) {
  return `${t * 6 / 100}em`;
}
function Te({
  format: t,
  top: e,
  right: o,
  bottom: n,
  left: r
}) {
  switch (t) {
    case J.Pixels:
      return `${e}${t} ${o}${t} ${n}${t} ${r}${t}`;
    case J.Em:
    default:
      return `${O(e)} ${O(o)} ${O(n)} ${O(r)}`;
  }
}
function ve(t) {
  return (t == null ? void 0 : t.constructor) === Object;
}
function F(t, e = 2) {
  return t.toFixed(0).padStart(e, "0");
}
function dt(t) {
  if (t < 0)
    return {
      hours: "00",
      minutes: "00",
      seconds: "00"
    };
  const e = Math.floor(t / 60), o = Math.floor(e / 60), n = Math.floor(o / 24), r = {
    // Warn: order of key-values of the object *is* critical for display
    days: F(n),
    hours: F(o % 24),
    minutes: F(e % 60),
    seconds: F(t % 60)
  };
  return n ? delete r.seconds : delete r.days, r;
}
var T = {};
Object.defineProperty(T, "__esModule", { value: !0 });
T.TokenData = void 0;
T.parse = P;
T.compile = Ae;
T.match = Me;
T.pathToRegexp = Le;
const ke = "/", _ = (t) => t, je = new RegExp("^\\p{XID_Continue}$", "u"), x = "https://git.new/pathToRegexpError", Ee = {
  "!": "!",
  "@": "@",
  ";": ";",
  ",": ",",
  "*": "*",
  "+": "+",
  "?": "?",
  "{": "{",
  "}": "}"
};
function Ce(t) {
  const e = [...t], o = [];
  let n = 0;
  for (; n < e.length; ) {
    const r = e[n], s = Ee[r];
    if (s) {
      o.push({ type: s, index: n++, value: r });
      continue;
    }
    if (r === "\\") {
      o.push({ type: "ESCAPED", index: n++, value: e[n++] });
      continue;
    }
    if (r === ":") {
      let a = "";
      for (; je.test(e[++n]); )
        a += e[n];
      if (!a)
        throw new TypeError(`Missing parameter name at ${n}`);
      o.push({ type: "NAME", index: n, value: a });
      continue;
    }
    if (r === "(") {
      const a = n++;
      let c = 1, i = "";
      if (e[n] === "?")
        throw new TypeError(`Pattern cannot start with "?" at ${n}`);
      for (; n < e.length; ) {
        if (e[n] === "\\") {
          i += e[n++] + e[n++];
          continue;
        }
        if (e[n] === ")") {
          if (c--, c === 0) {
            n++;
            break;
          }
        } else if (e[n] === "(" && (c++, e[n + 1] !== "?"))
          throw new TypeError(`Capturing groups are not allowed at ${n}`);
        i += e[n++];
      }
      if (c)
        throw new TypeError(`Unbalanced pattern at ${a}`);
      if (!i)
        throw new TypeError(`Missing pattern at ${a}`);
      o.push({ type: "PATTERN", index: n, value: i });
      continue;
    }
    o.push({ type: "CHAR", index: n, value: e[n++] });
  }
  return o.push({ type: "END", index: n, value: "" }), new Se(o);
}
class Se {
  constructor(e) {
    this.tokens = e, this.index = 0;
  }
  peek() {
    return this.tokens[this.index];
  }
  tryConsume(e) {
    const o = this.peek();
    if (o.type === e)
      return this.index++, o.value;
  }
  consume(e) {
    const o = this.tryConsume(e);
    if (o !== void 0)
      return o;
    const { type: n, index: r } = this.peek();
    throw new TypeError(`Unexpected ${n} at ${r}, expected ${e}: ${x}`);
  }
  text() {
    let e = "", o;
    for (; o = this.tryConsume("CHAR") || this.tryConsume("ESCAPED"); )
      e += o;
    return e;
  }
  modifier() {
    return this.tryConsume("?") || this.tryConsume("*") || this.tryConsume("+");
  }
}
class M {
  constructor(e, o) {
    this.tokens = e, this.delimiter = o;
  }
}
T.TokenData = M;
function P(t, e = {}) {
  const { encodePath: o = _, delimiter: n = o(ke) } = e, r = [], s = Ce(t);
  let a = 0;
  do {
    const c = s.text();
    c && r.push(o(c));
    const i = s.tryConsume("NAME"), d = s.tryConsume("PATTERN");
    if (i || d) {
      r.push({
        name: i || String(a++),
        pattern: d
      });
      const u = s.peek();
      if (u.type === "*")
        throw new TypeError(`Unexpected * at ${u.index}, you probably want \`/*\` or \`{/:foo}*\`: ${x}`);
      continue;
    }
    if (s.tryConsume("*")) {
      r.push({
        name: String(a++),
        pattern: `(?:(?!${E(n)}).)*`,
        modifier: "*",
        separator: n
      });
      continue;
    }
    if (s.tryConsume("{")) {
      const u = s.text(), l = s.tryConsume("NAME"), p = s.tryConsume("PATTERN"), m = s.text(), h = s.tryConsume(";") && s.text();
      s.consume("}");
      const f = s.modifier();
      r.push({
        name: l || (p ? String(a++) : ""),
        prefix: o(u),
        suffix: o(m),
        pattern: p,
        modifier: f,
        separator: h
      });
      continue;
    }
    s.consume("END");
    break;
  } while (!0);
  return new M(r, n);
}
function Ae(t, e = {}) {
  const o = t instanceof M ? t : P(t, e);
  return De(o, e);
}
function xe(t, e) {
  if (typeof t == "string")
    return () => t;
  const o = e || _, n = t.modifier === "+" || t.modifier === "*", r = t.modifier === "?" || t.modifier === "*", { prefix: s = "", suffix: a = "", separator: c = a + s } = t;
  if (e && n) {
    const d = (l, p) => {
      if (typeof l != "string")
        throw new TypeError(`Expected "${t.name}/${p}" to be a string`);
      return o(l);
    }, u = (l) => {
      if (!Array.isArray(l))
        throw new TypeError(`Expected "${t.name}" to be an array`);
      return l.length === 0 ? "" : s + l.map(d).join(c) + a;
    };
    return r ? (l) => {
      const p = l[t.name];
      return p == null ? "" : p.length ? u(p) : "";
    } : (l) => {
      const p = l[t.name];
      return u(p);
    };
  }
  const i = (d) => {
    if (typeof d != "string")
      throw new TypeError(`Expected "${t.name}" to be a string`);
    return s + o(d) + a;
  };
  return r ? (d) => {
    const u = d[t.name];
    return u == null ? "" : i(u);
  } : (d) => {
    const u = d[t.name];
    return i(u);
  };
}
function De(t, e) {
  const { encode: o = encodeURIComponent, loose: n = !0, validate: r = !0, strict: s = !1 } = e, a = ee(e), c = X(n, t.delimiter), i = ne(t, c, [], a, s), d = t.tokens.map((u, l) => {
    const p = xe(u, o);
    if (!r || typeof u == "string")
      return p;
    const m = new RegExp(`^${i[l]}$`, a);
    return (h) => {
      const f = p(h);
      if (!m.test(f))
        throw new TypeError(`Invalid value for "${u.name}": ${JSON.stringify(f)}`);
      return f;
    };
  });
  return function(u = {}) {
    let l = "";
    for (const p of d)
      l += p(u);
    return l;
  };
}
function Me(t, e = {}) {
  const { decode: o = decodeURIComponent, loose: n = !0 } = e, r = t instanceof M ? t : P(t, e), s = X(n, r.delimiter), a = [], c = te(r, a, e), i = a.map((d) => {
    if (o && (d.modifier === "+" || d.modifier === "*")) {
      const { prefix: u = "", suffix: l = "", separator: p = l + u } = d, m = new RegExp(s(p), "g");
      return (h) => h.split(m).map(o);
    }
    return o || _;
  });
  return function(d) {
    const u = c.exec(d);
    if (!u)
      return !1;
    const { 0: l, index: p } = u, m = /* @__PURE__ */ Object.create(null);
    for (let h = 1; h < u.length; h++) {
      if (u[h] === void 0)
        continue;
      const f = a[h - 1], b = i[h - 1];
      m[f.name] = b(u[h]);
    }
    return { path: l, index: p, params: m };
  };
}
function E(t) {
  return t.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
function Re(t, e) {
  const o = E(t);
  return e ? `(?:${o})+(?!${o})` : o;
}
function X(t, e) {
  if (!t)
    return E;
  const o = new RegExp(`(?:(?!${E(e)}).)+|(.)`, "g");
  return (n) => n.replace(o, Re);
}
function ee(t) {
  return t.sensitive ? "" : "i";
}
function te(t, e, o) {
  const { trailing: n = !0, loose: r = !0, start: s = !0, end: a = !0, strict: c = !1 } = o, i = ee(o), d = X(r, t.delimiter), u = ne(t, d, e, i, c);
  let l = s ? "^" : "";
  return l += u.join(""), n && (l += `(?:${d(t.delimiter)})?`), l += a ? "$" : `(?=${E(t.delimiter)}|$)`, new RegExp(l, i);
}
function ne(t, e, o, n, r) {
  const s = `(?:(?!${E(t.delimiter)}).)+?`;
  let a = "", c = !0;
  return t.tokens.map((i, d) => {
    if (typeof i == "string")
      return a = i, e(i);
    const { prefix: u = "", suffix: l = "", separator: p = l + u, modifier: m = "" } = i, h = e(u), f = e(l);
    if (i.name) {
      const b = i.pattern ? `(?:${i.pattern})` : s, k = ze(b, i.name, n);
      if (c || (c = V(k, u || a)), !c)
        throw new TypeError(`Ambiguous pattern for "${i.name}": ${x}`);
      if (c = !r || V(k, l), a = "", o.push(i), m === "+" || m === "*") {
        const R = m === "*" ? "?" : "", C = e(p);
        if (!C)
          throw new TypeError(`Missing separator for "${i.name}": ${x}`);
        if (c || (c = !r || V(k, p)), !c)
          throw new TypeError(`Ambiguous pattern for "${i.name}" separator: ${x}`);
        return c = !r, `(?:${h}(${b}(?:${C}${b})*)${f})${R}`;
      }
      return `(?:${h}(${b})${f})${m}`;
    }
    return `(?:${h}${f})${m}`;
  });
}
function ze(t, e, o) {
  try {
    return new RegExp(`^${t}$`, o);
  } catch (n) {
    throw new TypeError(`Invalid pattern for "${e}": ${n.message}`);
  }
}
function V(t, e) {
  return e ? !t.test(e) : !1;
}
function Le(t, e = {}) {
  const o = t instanceof M ? t : P(t, e), n = [], r = te(o, n, e);
  return Object.assign(r, { keys: n });
}
var Oe = typeof global == "object" && global && global.Object === Object && global, Fe = typeof self == "object" && self && self.Object === Object && self, Ie = Oe || Fe || Function("return this")(), I = Ie.Symbol;
I && I.toStringTag;
I && I.toStringTag;
var Pe = Function.prototype, Ve = Pe.toString;
Ve.call(Object);
const v = ({
  langCode: t,
  mapper: e,
  number: o,
  keysLength: n
}) => {
  if (o === 0) return 0;
  const r = new Intl.PluralRules(t).select(o), s = e[r];
  return Math.min(
    n <= Object.keys(e).length ? s - 1 : s,
    n - 1
  );
}, Ue = (t, e) => v({
  langCode: "en-EN",
  mapper: { one: 1, other: 2 },
  number: t,
  keysLength: e
}), Ne = (t, e) => {
  const o = new Intl.PluralRules("ar-EG").select(t), n = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
  }[o];
  return Math.min(n, e - 1);
}, U = (t, e) => v({
  langCode: "ru-RU",
  mapper: { one: 1, few: 2, many: 3 },
  number: t,
  keysLength: e
}), Be = (t, e) => v({
  langCode: "ro-RO",
  mapper: { one: 1, few: 2, other: 3 },
  number: t,
  keysLength: e
}), He = (t, e) => v({
  langCode: "pl-PL",
  mapper: { one: 1, few: 2, many: 3 },
  number: t,
  keysLength: e
}), _e = (t, e) => v({
  langCode: "is-IS",
  mapper: { one: 1, other: 2 },
  number: t,
  keysLength: e
}), Xe = (t, e) => v({
  langCode: "hr-HR",
  mapper: { one: 1, few: 2, other: 3 },
  number: t,
  keysLength: e
}), Ke = (t, e) => v({
  langCode: "cs-CZ",
  mapper: { one: 1, few: 2, other: 3 },
  number: t,
  keysLength: e
}), $ = () => 0, Ze = {
  ar: Ne,
  cs: Ke,
  hr: Xe,
  id: $,
  is: _e,
  ja: $,
  ko: $,
  lt: U,
  pl: He,
  ro: Be,
  ru: U,
  uk: U,
  th: $,
  vi: $,
  zh: $,
  "zh-TW": $
};
function qe(t, e, o, n, r) {
  const c = (Ze[t || "en"] ?? Ue)(e, 2);
  return !c && r === "lastReservation" ? o.replace(n.hours, n.hour) : !c && ["nowViewing", "todayViewed", "bookedToday"].includes(r) ? o.replace(n.people, n.person) : o;
}
function N(t) {
  const e = /^(&|&amp;|a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i, o = /([A-Za-z0-9\u00C0-\u00FF])/, n = /([ :–—-])/;
  return t.split(n).map((r, s, a) => r.search(e) > -1 && s !== 0 && s !== a.length - 1 && a[s - 3] !== ":" && a[s + 1] !== ":" && (a[s + 1] !== "-" || a[s - 1] === "-" && a[s + 1] === "-") ? r.toLowerCase() : r.substring(1).search(/[A-Z]|\../) > -1 || a[s + 1] === ":" && a[s + 2] !== "" ? r : r.replace(o, (c) => c.toUpperCase())).join("");
}
function We(t, e) {
  switch (t) {
    case "opacity":
      return (parseInt(e, 10) / 100).toString();
    case "thickness":
      return ye(parseInt(e, 10));
    case "cssName":
      return `'${e}'`;
    default:
      return e;
  }
}
function Ge(t, e) {
  switch (t) {
    case "cornerRadius":
      return $e(e);
    case "padding":
      return Te(e);
    default:
      return null;
  }
}
function oe(t, e) {
  return Object.keys(t).reduce((o, n) => {
    var s;
    let r = We(n, (s = t[n]) == null ? void 0 : s.toString());
    return ve(t[n]) && (r = Ge(n, t[n]), !r) ? {
      ...o,
      ...oe(t[n], `${e}-${Y(n)}`)
    } : (o[`${e}-${Y(n)}`] = r, o);
  }, {});
}
class Je {
  constructor() {
    w(this, "rootDom", null);
    w(this, "state", D({
      colors: {},
      fonts: {},
      button: {},
      background: {},
      secondaryButton: {},
      overlay: {}
    }));
  }
  get rootElement() {
    return this.rootDom;
  }
  get fonts() {
    return this.state.fonts;
  }
  get backgroundImage() {
    var e, o;
    return (o = (e = this.state.background.image) == null ? void 0 : e.urls) == null ? void 0 : o.edited;
  }
  get backgroundImageAlt() {
    var e;
    return (e = this.state.background.image) == null ? void 0 : e.alt;
  }
  get colors() {
    return this.state.colors;
  }
  get button() {
    return this.state.button;
  }
  initialize(e, o) {
    var r, s, a, c, i, d, u, l, p, m, h, f, b, k, R, C, K, Z, q;
    this.rootDom = o, this.state.colors = e.colors || {}, this.state.fonts = e.fonts || {}, this.state.button = e.button || {}, this.state.secondaryButton = e.secondaryButton || {}, this.state.background = e.background || {}, this.state.overlay = e.overlay || {};
    const n = oe(this.state, "--thn-tool");
    this.addCssVariables({
      ...n,
      "--thn-tool-colors-icon-back": we(((r = e.colors) == null ? void 0 : r.icon) || "#000000", 0.15),
      "--thn-tool-colors-background": (a = (s = e.colors) == null ? void 0 : s.background) != null && a.gradient ? `linear-gradient(to right bottom, ${(i = (c = e.colors) == null ? void 0 : c.background) == null ? void 0 : i.base}, ${(u = (d = e.colors) == null ? void 0 : d.background) == null ? void 0 : u.gradient})` : (p = (l = e.colors) == null ? void 0 : l.background) == null ? void 0 : p.base,
      "--thn-tool-button-background-color": ((m = e.button) == null ? void 0 : m.style) === z.Solid ? (h = e.colors) == null ? void 0 : h.buttonBackground : "transparent",
      "--thn-tool-button-border": ((f = e.button) == null ? void 0 : f.style) === z.Outline ? `solid 2px ${(b = e.colors) == null ? void 0 : b.buttonBackground}` : "transparent",
      "--thn-tool-secondary-button-background-color": ((k = e.secondaryButton) == null ? void 0 : k.style) === z.Solid ? (R = e.colors) == null ? void 0 : R.secondaryButtonBackground : "transparent",
      "--thn-tool-secondary-button-border": ((C = e.secondaryButton) == null ? void 0 : C.style) === z.Outline ? `solid 2px ${(K = e.colors) == null ? void 0 : K.secondaryButtonBackground}` : "transparent",
      "--thn-tool-background-border": (q = (Z = e.background) == null ? void 0 : Z.border) != null && q.color ? `solid ${n["--thn-tool-background-border-thickness"]} ${e.background.border.color}` : "none"
    });
  }
  addCssVariables(e) {
    Object.keys(e).forEach((o) => {
      var n;
      (n = this.rootDom) == null || n.style.setProperty(o, e[o] || "");
    });
  }
  getCssVariableValue(e) {
    return this.rootDom && getComputedStyle(this.rootDom).getPropertyValue(e);
  }
}
const Qe = (t, e, o) => {
  const n = t[e];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((r, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      s.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== o ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
class Ye {
  constructor() {
    w(this, "state", D({
      language: y.English,
      device: B.Desktop,
      literals: {}
    }));
  }
  get device() {
    return this.state.device;
  }
  get language() {
    return this.state.language;
  }
  async initialize(e, o) {
    this.state.language = e ?? y.English, this.state.device = o ?? B.Desktop;
    const n = await Qe(/* @__PURE__ */ Object.assign({ "../locales/ar.json": () => import("./ar.BctCv3FP.js"), "../locales/bg.json": () => import("./bg.CuDNZ7da.js"), "../locales/ca.json": () => import("./ca.Q-LZDm9_.js"), "../locales/cs.json": () => import("./cs.gnCu98bQ.js"), "../locales/da.json": () => import("./da.Se920Ge4.js"), "../locales/de.json": () => import("./de.B-zFayrI.js"), "../locales/el.json": () => import("./el.PANRCSoe.js"), "../locales/en.json": () => import("./en.fNPZPFmZ.js"), "../locales/es.json": () => import("./es.B5CqWAFG.js"), "../locales/et.json": () => import("./et.D9S1nzm2.js"), "../locales/eu.json": () => import("./eu.CQCeHw9K.js"), "../locales/fi.json": () => import("./fi.HRyMC976.js"), "../locales/fr.json": () => import("./fr.C2V16yxb.js"), "../locales/he.json": () => import("./he.D0nViRhb.js"), "../locales/hr.json": () => import("./hr.DR0Ump6x.js"), "../locales/hu.json": () => import("./hu.BnZnlacl.js"), "../locales/id.json": () => import("./id.DGr7QnIw.js"), "../locales/is.json": () => import("./is.DYhu72Ih.js"), "../locales/it.json": () => import("./it.D5Dyo-cr.js"), "../locales/ja.json": () => import("./ja.CL3rYoWi.js"), "../locales/ko.json": () => import("./ko.DGeLAjZl.js"), "../locales/lt.json": () => import("./lt.D4qV3oOi.js"), "../locales/nl.json": () => import("./nl.BmkF92Zz.js"), "../locales/no.json": () => import("./no.CtJFmNk6.js"), "../locales/pl.json": () => import("./pl.CefDvDGU.js"), "../locales/pt.json": () => import("./pt.bY1_UgE4.js"), "../locales/ro.json": () => import("./ro.CRAfRit8.js"), "../locales/ru.json": () => import("./ru.Dw-PR8qG.js"), "../locales/sk.json": () => import("./sk.DKNhq5Yx.js"), "../locales/sl.json": () => import("./sl.DbdEMFoc.js"), "../locales/sv.json": () => import("./sv.IWJTf2n0.js"), "../locales/th.json": () => import("./th.CDpBzJ5t.js"), "../locales/tr.json": () => import("./tr.3jjLVtfq.js"), "../locales/uk.json": () => import("./uk.BYYmR8rf.js"), "../locales/vi.json": () => import("./vi.CE5F6H_Y.js"), "../locales/zh-TW.json": () => import("./zh-TW.Dp9dRTh1.js"), "../locales/zh.json": () => import("./zh.DRrt0rlt.js") }), `../locales/${this.state.language}.json`, 3);
    this.state.literals = n.default;
  }
  getLiteral(e, o) {
    return o ? N(this.state.literals[e] || e) : this.state.literals[e] || e;
  }
  getLiteralAbb(e, o) {
    const n = `${e}_abbr`;
    return this.getLiteral(n, o);
  }
  getActivityLiteral(e, o = {}) {
    const n = o[e], r = qe(
      this.state.language,
      Number(n),
      this.state.literals[de[e]],
      this.state.literals,
      e
    );
    return n ? r == null ? void 0 : r.replace("XXXXXX", n) : r;
  }
  getPerkActiveLiteral(e, o = !1) {
    const n = e[this.state.language] ?? "";
    return o ? N(n) : n;
  }
  getPerkTooltipLiteral(e) {
    return this.state.literals[pe[e]];
  }
  getActiveModuleText(e, o = !1, n) {
    let r = e[this.device][this.language] ?? "";
    if (n) {
      const { candidates: s = [], replacement: a = {} } = n;
      s.forEach((c) => {
        const i = a[c];
        if (!i)
          throw Error("The tool cannot be shown if any of the tokens do not have a correct replacement value");
        r = r.replaceAll(`{${c}}`, i);
      });
    }
    return o ? N(r) : r;
  }
  getLocaleImageUrl(e) {
    var o;
    switch (e.languageType) {
      case L.Multi:
        return (o = e.urls[this.language || y.English]) == null ? void 0 : o.edited;
      case L.Single:
      default:
        return e.urls.edited;
    }
  }
  getLocaleImageAlt(e) {
    switch (e.languageType) {
      case L.Multi:
        return e.alt[this.language || y.English];
      case L.Single:
      default:
        return e.alt;
    }
  }
}
class et {
  constructor() {
    w(this, "initTime", Date.now());
    w(this, "state", D({
      builderMode: !1,
      firstVisitDate: null,
      hotelTimezone: "Europe/Madrid",
      defaultAssets: void 0,
      countdownTimestamp: void 0,
      tokens: {},
      dynamicTags: []
    }));
  }
  get countdownInitTime() {
    return this.initTime;
  }
  get builderMode() {
    return this.state.builderMode;
  }
  get defaultAssets() {
    return this.state.defaultAssets;
  }
  get countdownTimestamp() {
    return this.state.countdownTimestamp;
  }
  get tokens() {
    return this.state.tokens;
  }
  get dynamicTags() {
    return this.state.dynamicTags;
  }
  initialize(e) {
    this.state.builderMode = !!e.builderMode, this.state.firstVisitDate = e.firstVisitDate, this.state.hotelTimezone = e.hotelTimezone, this.state.hotelTimezoneOffset = e.hotelTimezoneOffset, this.state.defaultAssets = e.defaultAssets, this.state.countdownTimestamp = e.countdownTimestamp, this.state.tokens = e.tokens, this.state.dynamicTags = e.dynamicTags;
  }
  getCountdownTimestamp(e, o) {
    const {
      date: n = Date.now(),
      timezone: r,
      days: s = 0,
      hours: a = 0,
      minutes: c = 0
    } = o;
    if (this.initTime = Date.now(), e === Q.Time) {
      const i = s * 24 * 60 * 60 * 1e3, d = a * 60 * 60 * 1e3, u = c * 60 * 1e3, l = this.state.firstVisitDate ? this.initTime - this.state.firstVisitDate : 0;
      return this.initTime + i + d + u - l;
    }
    if (e === Q.Date && n) {
      const i = new Date(n);
      if (i.setHours(a), i.setMinutes(c), r === he.Hotel)
        if (!this.state.hotelTimezoneOffset && this.state.hotelTimezone) {
          const d = (/* @__PURE__ */ new Date()).toLocaleString("en-US", {
            timeZone: this.state.hotelTimezone
          }), l = new Date(d).getTime() - (/* @__PURE__ */ new Date()).getTime();
          i.setTime(i.getTime() - l);
        } else this.state.hotelTimezoneOffset && i.setTime(i.getTime() - this.state.hotelTimezoneOffset);
      return i.getTime();
    }
    return null;
  }
}
const re = new Ye(), se = {}, ie = {};
function ae() {
  const t = H();
  return (t == null ? void 0 : t.uid) || 0;
}
function tt() {
  var e;
  const t = H();
  return (e = t == null ? void 0 : t.proxy) == null ? void 0 : e.$el;
}
function nt(t) {
  var n;
  const e = H(), o = (n = e == null ? void 0 : e.exposed) == null ? void 0 : n.hide;
  t.inited = !0, t.hideFunction = o || (() => {
  });
}
function ot(t) {
  const e = ae(), o = tt(), n = se[e];
  if (n.inited)
    n.language = t.language, n.rtl = t.language === y.Arabic || t.language === y.Hebrew, n.device = t.device, n.extraData.initialize(t.extraData), n.handlers.initialize(n.hideFunction, t.actions), n.literals.initialize(t.language, t.device), n.styles.initialize(t.styles, o);
  else
    throw new Error(`error updating store ${e}: store not inited`);
}
function pt(t) {
  const e = ae(), o = Symbol("useStore injection key"), n = D({
    uid: e,
    inited: !1,
    language: y.English,
    device: B.Desktop,
    hideFunction: () => {
    },
    extraData: new et(),
    handlers: new be(),
    literals: re,
    styles: new Je()
  });
  return se[e] = n, ie[e] = o, W(o, n), W("rootUID", e), le(() => {
    nt(n), ot(t);
  }), n;
}
function ht() {
  const t = G("rootUID");
  if (t !== void 0)
    return G(ie[t]);
  throw new Error("No UID found to load the store");
}
function mt() {
  return re;
}
export {
  A as B,
  Qe as _,
  Y as a,
  $e as b,
  ct as c,
  ye as d,
  ut as e,
  lt as f,
  qe as g,
  we as h,
  Te as i,
  ve as j,
  dt as k,
  N as l,
  pt as m,
  ht as n,
  mt as o,
  F as p,
  at as t,
  ot as u
};
//# sourceMappingURL=useStore.CDG6wbfK.js.map
